import {Boot, IButtonMenu, IDomEditor} from '@wangeditor/editor'
// @ts-ignore 代码格式化工具
// import prettier from 'prettier/standalone';
// @ts-ignore 格式化html
// import parserHtml from 'prettier/parser-html';


class MyWangEditorMenu1 implements IButtonMenu {
    // TS 语法
    // class MyButtonMenu {                       // JS 语法

    constructor() {
        this.title = 'HTML源码模式' // 自定义菜单标题
        this.iconSvg = '<svg t="1743521083019" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="13725" xmlns:xlink="http://www.w3.org/1999/xlink" width="200" height="200"><path d="M933.875 747.1953125V775.671875a158.203125 158.203125 0 0 1-158.203125 158.203125H248.328125a158.203125 158.203125 0 0 1-158.203125-158.203125v-28.37109375h68.50195313l0.05273437 28.37109375a89.6484375 89.6484375 0 0 0 89.6484375 89.6484375h527.34375a89.6484375 89.6484375 0 0 0 89.6484375-89.6484375v-28.37109375H933.875zM775.671875 90.125a158.203125 158.203125 0 0 1 158.203125 158.203125v28.31835938h-68.5546875v-28.31835938a89.6484375 89.6484375 0 0 0-89.6484375-89.6484375H248.328125a89.6484375 89.6484375 0 0 0-89.6484375 89.6484375l-0.05273438 28.31835938H90.125v-28.31835938a158.203125 158.203125 0 0 1 158.203125-158.203125h527.34375zM233.5625 395.93164062v85.11328126H148.44921875V395.93164062h-52.20703125v221.48437501h52.20703125V523.75976563H233.5625v93.65624999h52.20703125v-221.48437499zM310.1328125 438.64648437h56.953125v178.76953126h52.5234375v-178.76953126h56.953125v-42.71484374H310.1328125zM591.734375 617.41601563h61.3828125l37.96875-182.25000001h2.53125v182.25000001h50.30859375v-221.48437501h-90.80859375l-30.05859375 158.51953126-0.6328125 3.16406249-0.6328125-3.1640625-30.05859375-158.51953124H500.92578125v221.48437499h50.30859375V435.16601562h2.84765625zM781.89453125 395.93164062v221.48437501h141.75v-42.71484376h-89.54296875v-178.76953124z" fill="#000000" p-id="13726"></path></svg>'
        this.tag = 'button'
    }

    // 获取菜单执行时的 value ，用不到则返回空 字符串或 false
    getValue(editor: IDomEditor): string | boolean {
        // TS 语法
        // getValue(editor) {                              // JS 语法
        return ' hello '
    }

    // 菜单是否需要激活（如选中加粗文本，“加粗”菜单会激活），用不到则返回 false
    isActive(editor: IDomEditor): boolean {
        // TS 语法
        // isActive(editor) {                    // JS 语法
        return false
    }

    // 菜单是否需要禁用（如选中 H1 ，“引用”菜单被禁用），用不到则返回 false
    isDisabled(editor: IDomEditor): boolean {
        // TS 语法
        // isDisabled(editor) {                     // JS 语法
        return false
    }

    // 点击菜单时触发的函数
    exec(editor: IDomEditor, v: string | boolean) {
        // TS 语法
        // exec(editor, value) {                              // JS 语法
        // if (this.isDisabled(editor)) return
        // editor.insertText('value') // value 即 this.value(editor) 的返回值

        let value = editor.getHtml();
        editor.clear();
        // if (active) {
            // 将html代码转换为html代码块 dangerouslyInsertHtml是插入html不是重置html，如果使用setHtml也会报节点异常
            // editor.dangerouslyInsertHtml(parseEditorCode(value));
        // } else {
            //  将html代码块转换为editor的html
            // editor.dangerouslyInsertHtml(parseCodeEditor(value));
            // value = parseCodeEditor(value);
        // }
    }

    readonly tag: string;
    readonly title: string;
    readonly iconSvg: string;
}


/**
 * 在编辑器中得到的html源码是没有格式的html字符串
 * 所以需要格式化展示代码
 * 格式化html代码
 * @param code
 */
export const parserHtmlCode = (code: string): string => {
    try {
        return code;
        // return prettier.format(code, {
        //     parser: 'html',
        //     plugins: [parserHtml],
        //     // 格式化的标签不换行 例如span标签等>格式化后会换行
        //     htmlWhitespaceSensitivity: 'ignore'
        // });
    } catch (e) {
        console.error('格式化代码错误', e);
        return code;
    }
}

/**
 * 将编辑器html转换为代码块内容
 * @param html
 */
export const parseEditorCode = (html: string) => {
    let code = html
        .replace(/&nbsp;/g, '')
        .replace(new RegExp('<p><br></p>', 'g'), '');
    let data = parserHtmlCode(code).trim();
    let textCode = data
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/ /g, "&nbsp;");
    return `<pre><code class="language-html">${textCode}</code></pre>`;
}

/**
 * 将代码块转换为编辑器html
 * @param preCode 代码块
 */
export const parseCodeEditor = (preCode: string) => {
    // 转码
    let data = encodeURI(preCode);
    // 将&nbsp;转换为空格
    data = data.replace(/%C2%A0/g,'%20');
    // 解码
    data = decodeURI(data);
    let htmlStr = data
        .replace('<pre><code class="language-html">', '')
        .replace('</code></pre>', '')
        .replace(/&lt;/ig, "<")
        .replace(/&gt;/ig, ">");
    return htmlStr
        .replace(new RegExp('\\n', 'g'), '')
        .replace(new RegExp('<p><br></p>', 'g'), '')
        .trim();
}


export const menu1Conf = {
    key: 'sourceMode', // 定义 menu key ：要保证唯一、不重复（重要）
    factory() {
        return new MyWangEditorMenu1() // 把 `YourMenuClass` 替换为你菜单的 class
    },
}
